module.exports = __webpack_public_path__ + "static/media/angle-double-left.8bd1859a.svg";